import { render, staticRenderFns } from "./UpdatePasswordDialog.vue?vue&type=template&id=1270faf7&scoped=true&"
import script from "./UpdatePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePasswordDialog.vue?vue&type=style&index=0&id=1270faf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270faf7",
  null
  
)

export default component.exports